import { useMemo } from "react";
import { ViewOffSlashIcon } from "@hugeicons-pro/core-stroke-rounded";
import { NavItemId } from "../constants";
import { useNavCustomization } from "../use-nav-customization";
import { useNavItemCounts } from "../use-nav-item-counts";
import { NavCountPill } from "./NavCountPill";
import { NavLink } from "./NavLink";

export const HiddenUpdatesNotice = () => {
  const { sections, startCustomizing } = useNavCustomization();

  const hiddenItems = useMemo(
    () =>
      new Map(
        sections
          .flatMap(({ items }) => items)
          .filter(({ isHidden }) => isHidden)
          .map((item) => [item.id, item.name])
      ),
    [sections]
  );

  const counts = useNavItemCounts({
    isInboxEnabled: hiddenItems.has(NavItemId.INBOX),
    isUnitsEnabled: hiddenItems.has(NavItemId.UNITS)
  });

  const updates = [...counts]
    .map(([id, count]) => ({ id, count }))
    .filter(({ id, count }) => hiddenItems.has(id) && count > 0);

  if (!updates.length) return null;

  const total = updates.reduce((sum, { count }) => sum + count, 0);
  const label =
    updates.length === 1
      ? `${hiddenItems.get(updates[0].id)} is hidden`
      : `${updates.length} hidden items have updates`;

  return (
    <div className="px-4 pb-2">
      <NavLink HugeIcon={ViewOffSlashIcon} onClick={startCustomizing}>
        <span className="absolute left-7 top-2.5 size-2 rounded-full bg-danger-500 ring-2 ring-white" />
        <span className="flex min-w-0 flex-1 items-center justify-between gap-2">
          <span title={label} className="truncate">
            {label}
          </span>
          <NavCountPill count={total} />
        </span>
      </NavLink>
    </div>
  );
};
